import clsx from 'clsx'

// Small pill-style toggle shared by Session-2 dashboard cards. Keeps the
// button styling and a11y behaviour consistent across Activity Pulse /
// Health Interventions / Weighing Trend.
export default function PeriodToggle({ options, value, onChange, ariaLabel = 'Period' }) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="inline-flex rounded-full border border-gray-200 bg-gray-50 p-0.5 text-xs font-medium"
    >
      {options.map((opt) => {
        const selected = opt.value === value
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(opt.value)}
            className={clsx(
              'px-3 py-2 sm:py-1 min-h-[36px] sm:min-h-0 rounded-full transition-colors',
              selected
                ? 'bg-white text-primary-700 shadow-sm ring-1 ring-gray-200'
                : 'text-gray-500 hover:text-gray-700'
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
